export const initMetaPixel = () => {
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = "2.0"
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js")

  window.fbq = window.fbq || function () {
    (window.fbq.q = window.fbq.q || []).push(arguments)
  }

  window.fbq("init", "500050909411549") // Seu Pixel ID
  window.fbq("track", "PageView")
}

export const trackMetaEvent = (event, data = {}) => {
  if (window.fbq) {
    window.fbq("track", event, data)
  } else {
    console.error("Erro: fbq não está disponível.")
  }
}